import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store";
import {
  clearCart,
  removeItem,
  updateItemQuantity,
  updateHasServiceInCart,
} from "@/store/features/cartSlice";

export function useCartActions() {
  const dispatch = useDispatch();
  const cart = useSelector((state: RootState) => state.cart.items);

  const handleRemove = useCallback(
    (uniqueId: string) => {
      dispatch(removeItem(uniqueId));
      dispatch(updateHasServiceInCart());
    },
    [dispatch],
  );

  const handleClearCart = useCallback(() => {
    dispatch(clearCart());
    dispatch(updateHasServiceInCart());
  }, [dispatch]);

  const handleQuantityChange = useCallback(
    (itemId: string, increment: boolean) => {
      const item = cart.find((item) => item.uniqueId === itemId);
      if (item) {
        const newQuantity = increment
          ? item.quantity + 1
          : Math.max(item.quantity - 1, 1);
        dispatch(updateItemQuantity({ itemId, quantity: newQuantity }));
        dispatch(updateHasServiceInCart());
      }
    },
    [cart, dispatch],
  );

  return {
    handleRemove,
    handleClearCart,
    handleQuantityChange,
  };
}
